import Vue from "vue";
import websocket from "@/utils/websocket/index";
import http from "@/api/api";
import store from "@/store/index";
import { getTenantById } from "@/api/layout/index";
//TODO:获取后端验证码
export const getCodeAn = async () => {
  let res = await http.get("/code");
  return res;
};

//根据用户名查询租户列表
export const queryTenant = async (userName) => {
  let res = await http.get("/tenant/safeTenant/queryTenant", { userName });
  return res;
};

//登陆
export const login = async (userInfo) => {
  let res = await http.post("/auth/tenant/login", userInfo);
  console.log(res);
  if (res.code == 200) {
    localStorage.setItem("user", JSON.stringify(res.data.user.safeTenantUser));
    localStorage.setItem("Authorization", `${res.data.access_token}`);
    // 本地保存token
    localStorage.setItem(
      "tenantId",
      JSON.stringify(res.data.user.safeTenantUser.tenantId)
    );
    //TODO:获取租户信息
    let tenant = await getTenantById(res.data.user.safeTenantUser.tenantId);
    console.log(tenant, '租户信息');
    if (tenant.code == 200) {
      localStorage.setItem("tenantInfo", JSON.stringify(tenant.data));
      store.commit("uploginTenant", tenant.data);

    }
    //存到vuex
    store.commit("uploginUser", res.data.user.safeTenantUser);
    // TODO: WebSocket 通过单例模式连接ws服务器：
    const wsInstance = websocket.Instance;
    wsInstance.newvue = this;
    // TODO: WebSocket 将websocket挂载到vue原型上：
    Vue.prototype.$ws = wsInstance;

    // 连接WebSocket
    wsInstance.connect(res.data.user.safeTenantUser.id);


  } else {
    // this.$hideLoading(); //关闭加载器
  }

  return res;
};

//启动证照预警定时任务
export const startCertifiesTask = async () => {
  let res = await http.get("/tenant/certifies/checkWarn");
  return res;
}
